import env from '@tencent/vft-common/env'
import weixin from '@tencent/vft-common/weixin'
import tenvideo from '@tencent/vft-common/tenvideo'
import { createNormalizer } from '@tencent/vft-common/urlFactory'

let normalizer = createNormalizer()
export function setShare (param, callback) {
  if (env.isWechat) {
    if (callback) {
      param.shareHandler = callback
    }
    weixin.setShare(param)
  } else if (tenvideo.isTenvideo()) {
    tenvideo.setShare(param)
    tenvideo.setOnShareHandler(callback)
  } else if (env.isMqq) {
    $.getScript('//open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
      mqq.data.setShareInfo({
        title: param.title,
        desc: param.desc,
        share_url: normalizer(param.link, false),
        image_url: normalizer(param.imgUrl, false)
      })
      mqq.ui.setOnShareHandler(function (type) {
        var res = {
          app: 'qq',
          shareTo: type
        }
        callback && callback(res)
        mqq.ui.shareMessage({
          share_type: type,
          title: param.title,
          desc: param.desc,
          share_url: normalizer(param.link, false),
          image_url: normalizer(param.imgUrl, false),
          sourceName: '腾讯视频VIP',
          back: true
        }, function (result) {
        })
      })
      // 隐藏底部导航条：
      mqq.ui.setWebViewBehavior({
        bottomBar: false
      })
    })
  }
}

export function hideShareButton () {
  if (env.isWechat) {
    weixin.hideOptionMenu()
  } else if (env.isApp) {
    tenvideo.hideMore()
  } else if (env.isMqq) {
    $.getScript('//open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
      mqq.ui.setWebViewBehavior({
        actionButton: 0
      })
    })
  }
}

// 用券后，显示分享按钮
export function showShareButton () {
  if (env.isWechat) {
    weixin.showOptionMenu()
  } else if (env.isApp) {
    tenvideo.showMore()
  } else if (env.isMqq) {
    $.getScript('//open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
      mqq.ui.setWebViewBehavior({
        actionButton: 1
      })
    })
  }
}
